import ColorPicker from '../inputs/ColorPicker';

const ColorValue = ({value, size}) => (
  <ColorPicker isReadOnly value={value} size={size}/>
);

export default ColorValue;
